import { Box } from "@mui/material";
import fonction1 from "../../../../ressources/images/fonction_1.png";
import fonction2 from "../../../../ressources/images/fonction_2.png";
import fonction3 from "../../../../ressources/images/fonction_3.png";
import fonction4 from "../../../../ressources/images/fonction_4.png";
import logoVert from "../../../../ressources/images/logo_vertuloo_vert.png";
import styles from "./styles";

function BlocFonctions() {
  const onClickEvent = () => {
    if (window.MatomoTagManager) {
      window._paq.push([
        "trackEvent",
        "Fonctions principales",
        "Clic - CTA",
        "Landing Page - Fonctions principales",
      ]);
    }
  };
  return (
    <Box sx={styles} className={"containerRelative"}>
      <div className={"container"}>
        <img src={logoVert} width={100} alt="immobilier & construction" />
        <h2>Les fonctions principales</h2>
        <h3>pour sécuriser votre portefeuille locatif</h3>
        <div className={"divider"} />

        <div className={"containerFonctions"}>
          <div className={"fonction"}>
            <img src={fonction1} width={50} alt="controle automatisé" />
            <p>Contrôle automatisé de l'authenticité et de la conformité</p>
            <span>des pièces du dossier de candidature de locataire.</span>
          </div>
          <div className={"fonction"}>
            <img src={fonction2} width={50} alt="analyse pragmatique" />
            <p>
              Analyse pragmatique et sécurisée de la solvabilité des candidats.
            </p>
          </div>
          <div className={"fonction"}>
            <img
              src={fonction3}
              width={50}
              alt="outil administrateurs de biens "
            />
            <p>
              Outil d'aide pour éclairer la prise de décisions de
              l'administrateur de biens
            </p>
          </div>
          <div className={"fonction"}>
            <img src={fonction4} width={25} alt="certification assurance" />
            <p>Certification assurance contre le risque de loyers impayés</p>
            <span>
              qui atteste l'effectivité du contrat pour 100% des dossiers
              acceptés
            </span>
          </div>
        </div>
        <div className={"grosRond"} />
        <div className={"moyenRond"} />
        <div className={"petitRond"} />
        <a
          href="/en-savoir-plus/#fonctions"
          className={"linkPlus"}
          onClick={onClickEvent}
        >
          en savoir plus
        </a>
      </div>
    </Box>
  );
}

export default BlocFonctions;
